<div class="version-warning-text cursor-pointer" (click)="reload()">
  A new version of Vorto Reload is available. Please refresh to get the latest version of the app.
</div>
